/*
 *
 * CheckoutStep3Page constants
 *
 */

enum ActionTypes {
  DEFAULT_ACTION = 'app/CheckoutStep3Page/DEFAULT_ACTION',
  GET_ORDER_DRAFT_REQUEST = 'app/CheckoutStep3Page/GET_ORDER_DRAFT_REQUEST',
  GET_ORDER_DRAFT_SUCCESS = 'app/CheckoutStep3Page/GET_ORDER_DRAFT_SUCCESS',
  GET_ORDER_DRAFT_FAILURE = 'app/CheckoutStep3Page/GET_ORDER_DRAFT_FAILURE',

  UPDATE_DELIVERY_DATE_TIME = 'app/CheckoutStep3Page/UPDATE_DELIVERY_DATE_TIME',
  UPDATE_DELIVERY_NOTES = 'app/CheckoutStep3Page/UPDATE_DELIVERY_NOTES',
  ADD_NOTE_SUBMIT = 'app/CheckoutStep3Page/ADD_NOTE_SUBMIT',
  REFRESH_ORDER_DRAFT = 'app/CheckoutStep3Page/REFRESH_ORDER_DRAFT',
}

export default ActionTypes;
